import { FieldRow as e } from "./FieldRow.es.js";
import { jsx as t } from "react/jsx-runtime";
//#region lib/TVListing/components/Channel.tsx
var n = ({ editor: n, element: r, options: i }) => {
	let a = i?.channelComponent;
	return /* @__PURE__ */ t(e, {
		editor: n,
		element: r,
		label: "Kanal",
		mandatory: !0,
		children: a && /* @__PURE__ */ t(a, {})
	});
};
//#endregion
export { n as Channel };
